import React, { FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setImagePath } from '../../utils/helpers';
import { capturePageLoadAnalytics } from '../../utils/analytics/analyticsDispatchers';
import { THANK_YOU_EVENT } from '../../utils/analytics/analyticsEvents';
import { getThankYouContent } from '../../store/contentSlice';
import './thankYou.css';

const ThankYou: FunctionComponent = () => {
  const { heading, message }: any = useSelector(getThankYouContent);
  useEffect(() => {
    capturePageLoadAnalytics(THANK_YOU_EVENT);
  }, []);

  return (
    <div className="error-pg-container">
      <div className="error-pg-box-wrapper">
        <div className="error-pg-img-wrapper">
          <img
            className="error-pg-img"
            src={setImagePath('thank-you-stopping-by')}
            alt="thanks for stopping by"
          />
        </div>
        <div className="error-message-wrapper" data-testid="thank-you-msg">
          <p className="error-pg-heading">{heading}</p>
          <p className="error-pg-message">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
